import request from '../axios'
import requestSec from '../axiosSec'

// 定制路径
// 路径分类
export const syscustomizeclassifyListAll = params => request({
	url: 'sys/syscustomizeclassify/listAll',
	method: 'get',
	params: params
})

// 路径列表
export const sysmenucustomizeList = params => request({
	url: 'sys/sysmenucustomize/list',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 获取路径详细信息
export const sysmenucustomizeInfo = params => request({
	url: 'sys/sysmenucustomize/info/' + params.id,
	method: 'get'
})

// 获取排序
export const sysmenucustomizeGetSort = params => request({
	url: 'sys/sysmenucustomize/getSort',
	method: 'get',
	params: params
})

// 获取分类（根据公共还是个人）
export const syscustomizeclassifyGetClassifyByBelong = params => request({
	url: 'sys/syscustomizeclassify/getClassifyByBelong',
	method: 'get',
	params: params
})

// 添加路径
export const sysmenucustomizeSave = data => request({
	url: 'sys/sysmenucustomize/save',
	method: 'post',
	data: data,
})

// 编辑路径
export const sysmenucustomizeUpdate = data => request({
	url: 'sys/sysmenucustomize/update',
	method: 'post',
	data: data,
})

// 删除路径
export const sysmenucustomizeDelete = data => request({
	url: 'sys/sysmenucustomize/delete',
	method: 'post',
	data: data,
})

// 获取路径配置
export const configmenucustomizeInfo = params => request({
	url: 'config/configmenucustomize/info',
	method: 'get',
	params: params
})

// 修改公共路径锁定许可（无参数，检测到开启自动关闭）
export const configmenucustomizeUpdatePath = data => request({
	url: 'config/configmenucustomize/updatePath',
	method: 'post',
	data: data,
})

// 设置位置
export const configmenucustomizeUpdateLocation = data => request({
	url: 'config/configmenucustomize/updateLocation',
	method: 'post',
	data: data,
})

// 新增分类
export const syscustomizeclassifySave = data => request({
	url: 'sys/syscustomizeclassify/save',
	method: 'post',
	data: data,
})

// 编辑分类
export const syscustomizeclassifyUpdate = data => request({
	url: 'sys/syscustomizeclassify/update',
	method: 'post',
	data: data,
})

// 移除分类
export const syscustomizeclassifyDelete = data => request({
	url: 'sys/syscustomizeclassify/delete',
	method: 'post',
	data: data,
})